import React from "react";

const FailedToLoadData = () => (
  <div className="text-center text-uppercase bold">
    Failed to load data, Please try again later.
  </div>
);

export default FailedToLoadData;



// WEBPACK FOOTER //
// ./src/components/common/errorBoundary/failedToLoadData/FailedToLoadData.js